import { configureStore } from '@reduxjs/toolkit'
import userSlice from './slice/userSlice'
export default configureStore({
  reducer: {
    userLoginInfo:userSlice
  },
})